import { createComponent } from "../utils";
import verb from "verb-nurbs-web";

export default createComponent({
  name: "Polyline",
  description: "Create a line",
  group: "Curve",
  icon: () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15" fill="none">
      <path
        d="M2 2L13 13M1.5 2.5C0.947715 2.5 0.5 2.05228 0.5 1.5C0.5 0.947715 0.947715 0.5 1.5 0.5C2.05228 0.5 2.5 0.947715 2.5 1.5C2.5 2.05228 2.05228 2.5 1.5 2.5ZM13.5 14.5C12.9477 14.5 12.5 14.0523 12.5 13.5C12.5 12.9477 12.9477 12.5 13.5 12.5C14.0523 12.5 14.5 12.9477 14.5 13.5C14.5 14.0523 14.0523 14.5 13.5 14.5Z"
        stroke="currentColor"
      />
    </svg>
  ),
  controls: [],
  inputs: [
    {
      id: "points",
      name: "Points",
      type: "Point",
      list: true,
    },
  ],
  outputs: [
    {
      id: "polyline",
      name: "Polyline",
      type: "Curve",
      compute: ({ points = [[0, 0, 0]] }) => {
        console.log(points);

        const polyline = new window.rhino.Polyline();

        for (const point of points) {
          polyline.add(point[0], point[1], point[2]);
        }

        return polyline.toNurbsCurve();
      },
    },
  ],
});
